<script lang="ts">
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    function handleClick(e) {
        dispatch("login", {});
    }
</script>

<div class="hero is-fullheight-with-navbar no-sidebar no-navbar">
    <div class="hero-body">
        <div class="container">
            <div
                class="column is-offset-2 is-8 is-offset-1-mobile is-10-mobile"
            >
                <div class="box">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <button
                                class="button is-primary is-fullwidth"
                                on:click={handleClick}>Login</button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    @import "./styles/variables";

    .button {
        background-color: $dark-green;
    }
</style>
